import PropTypes from 'prop-types';
import { Card, CardBody } from 'reactstrap';

const ButtonsSection = ({ title, children }) => (
  <Card className="buttons-section card-border card--margin-bottom">
    <CardBody className="card--padding">
      <div className="buttons-section__title">{title}</div>
      <div className="buttons-section__divider" />
      <div className="buttons-section__buttons">{children}</div>
    </CardBody>
  </Card>
);

ButtonsSection.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
};

export default ButtonsSection;
